import { gql } from '@apollo/client';

export const READ_CORPORATE_ACCOUNT_PREFERENCE = gql`
  query Query {
    readCorporateAccountPreference
  }
`;
